var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackPhotoPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 195,
    viewBox: "0 0 310 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 309,
    height: 194,
    rx: 7.5,
    fill: "#FAFAFA",
    stroke: "#E9E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.874 74.6992H129.126C127.538 74.6992 126.251 76.0023 126.251 77.6097V118.356C126.251 119.963 127.538 121.266 129.126 121.266H180.874C182.461 121.266 183.749 119.963 183.749 118.356V77.6097C183.749 76.0023 182.461 74.6992 180.874 74.6992Z",
    stroke: "#919191",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.938 99.4387C146.463 99.4387 147.925 98.8254 149.004 97.7338C150.082 96.6421 150.688 95.1616 150.688 93.6178C150.688 92.074 150.082 90.5934 149.004 89.5018C147.925 88.4101 146.463 87.7969 144.938 87.7969C143.413 87.7969 141.951 88.4101 140.872 89.5018C139.794 90.5934 139.188 92.074 139.188 93.6178C139.188 95.1616 139.794 96.6421 140.872 97.7338C141.951 98.8254 143.413 99.4387 144.938 99.4387V99.4387Z",
    stroke: "#919191",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.624 103.802H172.249M153.562 108.168C153.562 105.852 152.654 103.631 151.036 101.994C149.419 100.356 147.225 99.4363 144.938 99.4363C142.65 99.4363 140.457 100.356 138.839 101.994C137.222 103.631 136.313 105.852 136.313 108.168H153.562ZM160.75 92.1602H172.249H160.75Z",
    stroke: "#919191",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackPhotoPlaceholder);
export default __webpack_public_path__ + "static/media/back-photo-placeholder.5867fe2801948ebdfabff61070709af1.svg";
export { ForwardRef as ReactComponent };